<template>
    <star-rating
        :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
        inactive-color="#e5e7eb" active-color="#111" :round-start-rating="false" :show-rating="false"
        :star-size="currentSize.size" :rating="rating" :padding="currentSize.padding" :read-only="true"/>
</template>
<script>


import {defineAsyncComponent} from 'vue';

import lodash from 'lodash';


const {find} = lodash;
export default {
    components: {
        StarRating: defineAsyncComponent(() =>
            import('vue-star-rating')
        )
    },
    props: {
        size: {
            type: String,
            required: true
        },
        rating: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            sizes: [
                {
                    name: 'small',
                    size: 14,
                    padding: 3
                },
                {
                    name: 'large',
                    size: 24,
                    padding: 4
                }
            ]
        };
    },
    computed: {
        currentSize() {
            return find(this.sizes, {name: this.size});
        }
    }
};
</script>
